module.exports = [
  ...require('./_magicItemRawList_DMG_l'),
]
